import React from "react";
import "./styles.scss";

const GiveawayMastheadImageasBg: React.FC<any> = ({
  backgroundImage,
  tuneIn,
  tuneInColor,
  mobilebackground,
}) => {

  return (
    <>
    <div
      style={{ backgroundImage: `url("${backgroundImage}")` }}
      className="background desktop-bg"
    >
      <h3 style={{ color: tuneInColor }} className="giveaway-mh-tune-in">
        {tuneIn}
      </h3>
    </div>
    <div
      style={{ backgroundImage: `url("${mobilebackground}")` }}
      className="background mobile-bg"
    >
      <h3 style={{ color: tuneInColor }} className="giveaway-mh-tune-in">
        {tuneIn}
      </h3>
    </div>
    </>
  );
};

export default GiveawayMastheadImageasBg;
